import { Alert, Container, Divider, Paper, Snackbar, Stack, styled, Typography } from '@mui/material';
import { useState } from 'react';
import InviteAdminForm from '../../components/AdminInvite/InviteAdminForm';
import RoleMatrix from '../../components/UserManagement/RoleMatrix';
import UsersTable from '../../components/UserManagement/UsersTable';

const TextWrapper = styled('div')({
  gridColumn: '1/5',
});

const ContentWrapper = styled('div')({
  gridColumn: '6/13',
});

function UserManagement() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error'>('success');

  const handleSnackbarClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message: string, severity: 'success' | 'error') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Container sx={{ display: 'grid', gridTemplateColumns: 'repeat(12, 1fr);', gap: 8 }}>
        <TextWrapper>
          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
            }}
          >
            Invite
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              marginTop: 2,
            }}
          >
            Fill out the form to invite admin for the selected team.
          </Typography>
        </TextWrapper>
        <ContentWrapper>
          <Stack
            component={Paper}
            sx={{
              padding: 3,
              border: '1px solid #cbd5e0',
              boxShadow: 'none',
              height: '100%',
            }}
          >
            <InviteAdminForm />
          </Stack>
        </ContentWrapper>
      </Container>
      <Container>
        <Divider sx={{ marginY: 6 }} />
      </Container>
      <Container sx={{ marginBottom: 10, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <TextWrapper>
          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
            }}
          >
            Manage users
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              marginTop: 2,
            }}
          >
            View and manage all users across teams. Filter, edit a user, resend or cancel pending invites, or deactivate
            active users.
          </Typography>
        </TextWrapper>
        <UsersTable snackbarData={showSnackbar} />
      </Container>
      <Container>
        <Divider sx={{ marginY: 6 }} />
      </Container>
      <Container sx={{ marginBottom: 10, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <TextWrapper>
          <Typography
            variant='h5'
            sx={{
              fontWeight: 'bold',
            }}
          >
            Roles & permissions
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: 'text.secondary',
              marginTop: 2,
            }}
          >
            Overview of what each role can do. Higher roles inherit the permissions of the roles they extend.
          </Typography>
        </TextWrapper>
        <RoleMatrix />
      </Container>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default UserManagement;
